<template>
    <div class="product-card-block">
        <!-- Линия с фото и размерами -->
        <div class="product-card-block-line">

            <!-- Блок с фото и названием товара -->
            <div class="product-photo-block">
                <!-- Фото товара (в базе) -->
                <img :src="product.photo" alt="" class="product-photo-in-database">

                <!-- Блок с названием -->
                <div class="product-name-block">
                    {{ product.name }}
                </div>
            </div>

            
            <!-- Слайдер для хранения размеров и колчества -->
            <div class="size-slider">

                <!-- Блок заголовок размеров и количества -->
                <div class="size-block size-block-header">
                    <div class="size">Размер</div>
                    <div class="quantity">Количество</div>
                </div>

                <!-- Блок размера -->
                <div class="size-block" v-for="presence in product.presence.filter(p => p.quantity > 0)" :key="presence.size_name">
                    <div class="size">{{ presence.size_name }}</div>
                    <div class="quantity">{{ presence.quantity }} шт.</div>
                </div>

                <!-- Строка "На возврате" (товар едет от клиента к нам) -->
                <div class="return-line" v-if="onReturn.length > 0">
                    На возврате: {{ onReturnText }}
                </div>

            </div>
        </div>

        <!-- Линия с данными о товар и кнопками упралвения -->
        <div class="product-card-block-line-inverse">
            <!-- Данные о товаре -->
            <div class="product-data">

                <!-- Линия данных о продукте -->
                <div class="product-data-line">
                    <div class="data-label">Цена закупки: </div>
                    <div class="data-value">{{ product.purchase_price }} ₽</div>
                </div>

                <!-- Линия данных о продукте -->
                <div class="product-data-line">
                    <div class="data-label">Логистика: </div>
                    <div class="data-value">{{ product.delivery_price }} ₽</div>
                </div>

                <!-- Линия данных о продукте -->
                <div class="product-data-line">
                    <div class="data-label">Себестоимость: </div>
                    <div class="data-value">{{ product.purchase_price + product.delivery_price }} ₽</div>
                </div>

                <!-- Линия данных о продукте -->
                <div class="product-data-line">
                    <div class="data-label">Курс юаня: </div>
                    <div class="data-value">{{ product.exchange_rate }} ₽</div>
                </div>

                <!-- Линия данных о продукте -->
                <div class="product-data-line">
                    <div class="data-label">Категория: </div>
                    <div class="data-value">{{ product.category }}</div>
                </div>

            </div>

            
            <!-- Кнокпи управления -->
            <div class="setting-buttons-container">
                <buttun class="setting-button delete" @click="deleteProduct()">Удалить</buttun>
                <buttun class="setting-button edit" @click="updateProduct()">Изменить</buttun>
            </div>
        </div>

        <!-- Партии товара -->
        <div class="batches-block" v-if="batches.length">
            <div class="batches-header">Партии ({{ batches.length }})</div>
            <div class="batch-row" v-for="batch in batches" :key="batch.id">
                <div class="batch-row-main">
                    <span class="batch-label">{{ batch.label || `Партия #${batch.id}` }}</span>
                    <span class="batch-leading-badge" v-if="batch.is_leading">Ведущая</span>
                </div>
                <div class="batch-row-prices">
                    <span>Себестоимость: {{ batch.purchase_price + batch.delivery_price }} ₽</span>
                    <span v-if="batch.drop_price">Дроп: {{ batch.drop_price }} ₽</span>
                    <span v-if="batch.retail_price">Розница: {{ batch.retail_price }} ₽</span>
                    <span>Остаток: {{ batchTotalQuantity(batch) }} шт.</span>
                </div>
                <button
                    v-if="!batch.is_leading"
                    class="make-leading-button"
                    @click="makeLeading(batch)"
                    :disabled="makingLeadingId === batch.id"
                >
                    Сделать ведущей
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';

export default {
    props: {
        // Данные о товаре
        product: {
            type: Object,
            required: true
        }
    },

    emits: ['deleted', 'updated', 'refresh-requested'],
    data() {
        return {
            makingLeadingId: null,
        };
    },
    computed: {
        onReturn() {
            return this.product.on_return || [];
        },
        onReturnText() {
            return this.onReturn.map(item => `${item.size_name}-${item.quantity}`).join(' ');
        },
        batches() {
            return this.product.batches || [];
        },
    },
    methods: {
        batchTotalQuantity(batch) {
            return (batch.presence || []).reduce((sum, p) => sum + p.quantity, 0);
        },

        // Метод для кнопки 'Удалить'
        async deleteProduct() {
            const response = await api.delete(`/accounting_system/products/${this.product.id}`);

            // Обработка ответа сервера
            if (response.status === 200) {
                alert('Продукт успешно удалён.');
            } else {
                alert('Ошибка при удалении продукта.');
            }

            this.$emit('deleted');
        },

        // Метод для кнопки 'Изменить'
        updateProduct() {
            this.$emit('updated', this.product);
        },

        // Сделать партию ведущей
        async makeLeading(batch) {
            this.makingLeadingId = batch.id;
            try {
                await api.post(`/accounting_system/batches/${batch.id}/make-leading`);
                this.$emit('refresh-requested');
            } catch (error) {
                alert('Не удалось сделать партию ведущей');
            } finally {
                this.makingLeadingId = null;
            }
        },
    },
};
    
</script>

<style scoped>
.product-card-block {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    position: relative;
    min-height: 80vw;
    height: auto;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    padding: 2vw;
    color: white;
}

.batches-block {
    margin-top: 2vw;
    padding-top: 2vw;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.batches-header {
    font-size: 13px;
    font-weight: bold;
    color: #005ADA;
    margin-bottom: 1.5vw;
}

.batch-row {
    display: flex;
    flex-direction: column;
    gap: 1vw;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    padding: 2vw;
    margin-bottom: 1.5vw;
    font-size: 11px;
}

.batch-row-main {
    display: flex;
    align-items: center;
    gap: 1.5vw;
    font-weight: bold;
}

.batch-leading-badge {
    background-color: #2ecc71;
    color: #06240f;
    border-radius: 6px;
    padding: 0.5vw 1.5vw;
    font-size: 10px;
}

.batch-row-prices {
    display: flex;
    flex-wrap: wrap;
    gap: 2vw;
    color: rgba(255, 255, 255, 0.8);
}

.make-leading-button {
    align-self: flex-start;
    background-color: #005ADA;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 1.5vw 3vw;
    font-size: 11px;
    cursor: pointer;
}

.make-leading-button:disabled {
    opacity: 0.5;
}

.product-card-block-line {
    display: grid;
    grid-template-columns: 1fr 1fr ;
    gap: 2vw;
    height: 60%;
    margin-bottom: 2vw;
}

.product-photo-block {
    position: relative;
    height: 100%;
}

.product-name-block {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    text-align: center;
    padding: 1vw;
    font-size: 12px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
}

.product-photo-in-database {
    height: 44vw;
    width: 43.5vw;
    border-radius: 15px;
}

.size-slider {
    position: relative;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, .05);
    border-radius: 15px;
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    padding: 2vw;
}

.size-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    border-radius: 10px;
    padding: 1vw;
    background-color: rgba(255, 255, 255, 0.08);
    margin-bottom: 1vw;
}

.size-block-header {
    position: sticky;
    top: 0;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 2vw;
    background-color:  #005ADA;
    width: 100%;
    z-index: 10;
}

.size {
    text-align: left;
}

.quantity {
    text-align: right;
}

.return-line {
    margin-top: 1vw;
    padding: 1.5vw;
    border-radius: 10px;
    background-color: rgba(242, 145, 46, 0.15);
    border: 1px solid rgba(242, 145, 46, 0.35);
    color: #F2912E;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}

.product-card-block-line-inverse {
    display: grid;
    grid-template-columns: 1fr 1fr ;
    gap: 2vw;
    height: 40%;
}

.product-data-line {
    display: flex;
    gap: .5vw;
    margin-bottom: .5vw;
    font-size: 12px;
    align-items: center;
    background-color: rgba(255, 255, 255, .05);
    border-radius: 10px;
    padding: 0.25vw;
    justify-content: center;
}

.data-label {
    color:#005ADA;
}

.setting-buttons-container {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 1vw;

}

.setting-button {
    width: 44vw;
    height: 10vw;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.delete {
    background-color: #F71B47;
}

.edit {
    background-color: #F2912E;
}

</style>